/**
 * O "quando" do gatilho em palavras, para o bloco do começo.
 *
 * A lista das automações diz o mesmo (`pages/automacoes/area`). Uma página não
 * importa a outra; quando uma terceira tela precisar, o texto desce.
 */

import type { AutomacaoDaApi, BlocosDoEditor } from '@cliqcrm/contracts';
import { resumoDaAgenda } from './inicio';

export function resumoDoComeco(
  gatilho: AutomacaoDaApi['gatilho'],
  blocos: BlocosDoEditor | undefined,
): string {
  if (gatilho.tipo === 'interno') return 'Outra automação do mesmo modelo dispara esta';
  if (gatilho.tipo === 'evento') {
    return (
      blocos?.eventos.find((e) => e.evento === gatilho.evento)?.titulo ?? 'Algo acontece no CRM'
    );
  }
  // "Todo dia às 08:00", "De segunda a sexta às 09:00 e 14:00": a mesma frase do painel.
  return resumoDaAgenda(gatilho);
}
